/* script */
//
//
//

// Components
import PackageWizard from 'ui/components/PackageWizard.vue';

/**
 * This component will create a link to uninstall a package.
 *
 * @example
 * UninstallPackageButton(:module="module", :eventId="eventId", :orgId="orgId")
 *
 * @vue-prop {Object} module the package to uninstall
 * @vue-prop {String} eventId the ID of the event
 * @vue-prop {String} orgId the ID of the organization
 * @vue-prop {String} [context='']
 *
 * @category ui.components
 * @exports UninstallPackageButton
 * @component
 */
const __vue_script__ = {
    name: 'UninstallPackageButton',

    components: { PackageWizard },

    props: {
        module: {
            type: Object,
            required: true
        },
        eventId: {
            type: String,
            required: true
        },
        orgId: {
            type: String,
            required: true
        },
        context: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            canUninstall: false
        };
    },

    watch: {
        module() {
            this.init();
        }
    },

    created() {
        this.init();
    },

    methods: {
        /**
         * Since `module` can be reactive, we need this method to be called
         * on created but also on watch.
         */
        init() {
            this.canUninstall = !!this.module.can_be_uninstalled && this.$services.user.hasPermission('pkg_repo_realms.manage_event_packages', { event_id: this.eventId });
        },

        /**
         * Shows a modal to run the uninstall process.
         */
        async uninstall() {
            this.$modal.show(
                PackageWizard,
                {
                    module: this.module,
                    eventId: this.eventId,
                    orgId: this.orgId,
                    remove: true,
                    context: this.context
                },
                {
                    height: 'auto',
                    clickToClose: false
                }
            );
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canUninstall
    ? _c(
        "a",
        {
          staticClass: "danger",
          on: {
            click: function ($event) {
              return _vm.uninstall()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("marketplace.package.uninstall")))]
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/UninstallPackageButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__